import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import VideocamIcon from "@mui/icons-material/Videocam";
import { Box, Stack } from "@mui/material";
import type { StoryListItemDto } from "Infrastructure/Api/Api";
import { useState } from "react";

type Props = {
  story: StoryListItemDto;
  /** CSS aspect ratio of the frame, e.g. "3 / 4" for cards or "1 / 1" for table cells. */
  aspectRatio: string;
  onClick?: () => void;
};

/**
 * The story IMAGE only, lazily — videos are never downloaded in lists (a video-only story gets
 * a placeholder icon); the full media plays in the preview dialog. Media URLs are tick-stamped
 * and immutable, so no cache busting is needed.
 */
export const StoryMediaThumbnail = ({ story, aspectRatio, onClick }: Props) => {
  const [isImageBroken, setIsImageBroken] = useState(false);
  const hasLoadableImage = Boolean(story.imageUrl) && !isImageBroken;

  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        aspectRatio,
        bgcolor: "common.black",
        borderRadius: 1,
        overflow: "hidden",
        cursor: onClick ? "pointer" : undefined,
      }}
    >
      {hasLoadableImage ? (
        <img
          src={story.imageUrl ?? undefined}
          alt={story.text ?? ""}
          loading="lazy"
          decoding="async"
          onError={() => setIsImageBroken(true)}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          height="100%"
          color="grey.600"
        >
          {story.videoUrl ? (
            <VideocamIcon fontSize="large" />
          ) : (
            <ImageNotSupportedIcon fontSize="large" />
          )}
        </Stack>
      )}
    </Box>
  );
};
